import { Subject } from 'rxjs';

/**
 * Contact Builder lead-form tracking Subjects (NHS20-8253). This feature has no analytics
 * knowledge of its own — components only .next() raw, semantic payloads here (see
 * services/leadFormTracking.js, the only code that emits onto these). Payloads carry `fromPage`
 * (the raw data-from-page value the triggering CTA rendered), not any provider- or page-shaped
 * concept like "position" — translating that into e.g. Native ISM's `ISM-Plan`/`ISM-Spec` is the
 * consuming page's job (see pages/communityDetail/components/eventTracking/), since this feature
 * is shared and has no business knowing what "ISM" means. Whichever page embeds this feature
 * subscribes and shapes/dispatches the actual Segment/GA4 events.
 */
export const leadOptionSelectedOccurred$ = new Subject();
export const leadFormSubmittedOccurred$ = new Subject();
export const leadFormClosedOccurred$ = new Subject();
export const leadFormAbandonedOccurred$ = new Subject();
export const leadFormSubmissionFailedOccurred$ = new Subject();

/**
 * "Get on the list" (Coming Soon "Get Notified") tracking Subjects (NHS20-9093). Same shape as
 * the Contact Builder Subjects above, and consumed by the exact same GA4/Segment build*Event
 * functions (pages/communityDetail/components/eventTracking/) — NHS20-9093's tracking plan reuses
 * Contact Builder's event vocabulary verbatim for this form, just with a fixed 'Get on the list'
 * buttonName. Kept as this form's own session/Subjects rather than reusing leadFormTracking.js
 * directly, since components/getOnTheListForm.js has its own field set and opens directly from a
 * single CTA (no separate entry-modal "option selected" step) — see services/getOnTheListTracking.js.
 */
export const notifyFormOpenedOccurred$ = new Subject();
export const notifySubmitClickedOccurred$ = new Subject();
export const notifyModalClosedOccurred$ = new Subject();
export const notifyAbandonedOccurred$ = new Subject();
export const notifySubmissionFailedOccurred$ = new Subject();
